var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsUserSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 24H0V0h24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.744 16.539.256.001a1 1 0 0 1 .993.883l.007.117v2.56a1 1 0 0 1-1.993.117L17 20.1v-.169a7.672 7.672 0 0 1-1.551 1.127c-3.693 2.013-8.322.648-10.328-3.04a1 1 0 1 1 1.758-.956 5.611 5.611 0 0 0 7.61 2.242c.386-.213.746-.47 1.07-.764H15.4a1 1 0 0 1-.993-.883l-.007-.117a1 1 0 0 1 .883-.993l.117-.007 2.084-.002a.998.998 0 0 1 .26 0zm.336-6.546.122.01.113.005a3.948 3.948 0 0 1 3.682 3.79L22 14v1a1 1 0 0 1-1.993.117L20 15v-1.012a1.952 1.952 0 0 0-1.768-1.98l-.181-.011-.061.003h-2a1 1 0 0 1-.117-1.993L15.99 10h1.926l.029-.004.067-.004h.068zm-9 0 .122.01.113.005a3.948 3.948 0 0 1 3.682 3.79L13 14v1a1 1 0 0 1-1.993.117L11 15v-1.012a1.952 1.952 0 0 0-1.768-1.98l-.181-.011L8.99 12H5.972a1.937 1.937 0 0 0-1.975 1.758l-.01.183.003.049v1a1 1 0 0 1-1.993.117l-.007-.117-.001-.937-.004-.038c-.003-.05-.003-.1 0-.15l.008-.068.005-.123a3.932 3.932 0 0 1 3.79-3.673L8.916 10l.029-.004.067-.004h.068zM7.5 2a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7zM17 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6zM7.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM17 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2z",
    fill: "#111827",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsUserSwitch);
export default __webpack_public_path__ + "static/media/icons-user-switch.5fde14f768256d88eba3771559f04f59.svg";
export { ForwardRef as ReactComponent };